import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavigateActions } from '../../redux/actions';
import { restartIcon, printIcon, readyCheckIcon, bcLogoPrint } from '../../assets/images';
import Button from 'react-bootstrap/Button';
import { polyglot } from '../../assets/locales';
import { StepOne } from './StepOne';
import { StepTwo } from './StepTwo';
import { StepThree } from './StepThree';
import ROUTES from '../../constants/RouteConstants';
import { StepFour } from './StepFour';
import { GeneratedNoticePhase1 } from './GeneratedNotice';

class NoticeGenerator extends Component {
  state = {
    //step1 state
    stepOneData: {},
    stepTwoData: {},
    stepThreeData: {},

    stepOneSubmitted: false,
    stepTwoSubmitted: false,
    stepThreeSubmitted: false

  }

  componentDidMount() {
    if (this.props.location.pathname !== ROUTES.NOTICEGEN_STEP1) {
      this.props.navigate(ROUTES.NOTICEGEN_STEP1);
    }
  }

  setStepOneVars = (stepOneData) => {
    this.setState({ stepOneData });
  }

  setStepTwoVars = (stepTwoData) => {
    this.setState({ stepTwoData });
  }

  setStepThreeVars = (stepThreeData) => {
    this.setState({ stepThreeData });
  }

  setStepOneStatus = (stepCompleted) => {
    this.setState({ stepOneSubmitted: stepCompleted, stepTwoSubmitted: false, stepThreeSubmitted: false, stepTwoData: {}, stepThreeData: {} });
  };

  setStepTwoStatus = (stepCompleted) => {
    this.setState({ stepTwoSubmitted: stepCompleted, stepThreeSubmitted: false, stepThreeData: {} });
  }

  setStepThreeStatus = (stepCompleted) => {
    this.setState({ stepThreeSubmitted: stepCompleted });
  }

  resetForm = () => {
    window.location.reload(false);
  }

  generateNotice = () => {
    console.log('step1data: ', this.state.stepOneData);
    console.log('step2data: ', this.state.stepTwoData);
    console.log('step3data: ', this.state.stepThreeData);
    this.props.navigate(ROUTES.NOTICEGEN_STEP2);
  }

  print = () => {
    window.print();
  }

  editInformation = () => {
    this.props.navigate(ROUTES.NOTICEGEN_STEP1);
  }

  render() {
    const { location } = this.props;

    return (
      <div className="webtool-one">
        { location.pathname === ROUTES.NOTICEGEN_STEP1 ? this.renderSectionOne() : null }
        { location.pathname === ROUTES.NOTICEGEN_STEP2 ? this.renderSectionTwo() : null }
      </div>
    );
  }

  renderSectionOne() {
    const { stepOneSubmitted, stepTwoSubmitted, stepThreeSubmitted, stepOneData, stepTwoData, stepThreeData } = this.state;
    const { cpiConfig } = this.props;

    const hasFutureRIError = stepOneData.not1YearBetweenRentIncreases || stepOneData.not3MonthsForService;

    const renderGenerateNoticeButton = () => {
      if (!stepThreeData.isGeneratedNoticeAvailable || hasFutureRIError) return;
      return <Button variant="primary" className="w1-step-four__buttons__generate-notice" onClick={() => this.generateNotice()}>Generate Notice Insert</Button>
    }

    const renderSectionOneCompletedButtons = () => {
      if ( ((stepOneSubmitted && stepTwoSubmitted) && (stepThreeSubmitted || !stepTwoData.calcCPIValue)) || hasFutureRIError) {
        return (
          <>
            <p className="w1-step-four__completed-text hide-print">
              <span className="w1-step-four__completed-text__wrapper"><img className="w1-step-four__completed-text__icon" src={readyCheckIcon} alt=''/>Process Completed. {stepThreeData.isGeneratedNoticeAvailable ? 'If the above is information is correct you can use it to generate a rent increase notice insert.' : null}</span>
            </p>
            <div className="w1-step-four__buttons hide-print">
              { renderGenerateNoticeButton() }
              <span className="w1-step-four__buttons__print" onClick={() => this.print()}>
                <img className="w1-step-four__buttons__print__icon" src={printIcon} alt='' /> Print
              </span>
              <span className="w1-step-four__buttons__restart" onClick={() => this.resetForm()}>
                <img className="w1-step-four__buttons__print__icon" src={restartIcon} alt='' /> Start Over
              </span>
            </div>
          </>
        );
      }

      return;
    }

    return (
      <>
        <div className="w1-step-one__print-header">
          <img className="w1-step-one__print-header__icon" src={bcLogoPrint} alt="" />
          <p className="w1-step-one__header">Phase 1 Additional Rent Increase Calculator</p>
        </div>
        <p className="w1-step-one__header hide-print">Phase 1 Additional Rent Increase Calculation</p>
        <span className="w1-step-one__description" dangerouslySetInnerHTML={{ __html: polyglot.t('noticeGenerator.sectionOne.description', {firstYearDate: '2021', year: '2021' }) }}></span>
        <span className="w1-step-one__description-warning">&nbsp;{polyglot.t('noticeGenerator.sectionOne.descriptionWarning')}</span>
        <StepOne submitted={stepOneSubmitted} stepOneData={stepOneData} setStepOneStatus={this.setStepOneStatus} setStepOneVars={this.setStepOneVars} setStepTwoStatus={this.setStepTwoStatus} setStepThreeStatus={this.setStepThreeStatus} cpiConfig={cpiConfig}/>
        { stepOneSubmitted && !hasFutureRIError ? <StepTwo submitted={stepTwoSubmitted} stepOneData={stepOneData} stepTwoData={stepTwoData} setStepTwoStatus={this.setStepTwoStatus} setStepTwoVars={this.setStepTwoVars} cpiConfig={cpiConfig} /> : null }
        { stepOneSubmitted && stepTwoSubmitted && !hasFutureRIError && stepTwoData.calcCPIValue ? <StepThree submitted={stepThreeSubmitted} stepOneData={stepOneData} stepTwoData={stepTwoData} stepThreeData={stepThreeData} setStepThreeStatus={this.setStepThreeStatus} setStepThreeVars={this.setStepThreeVars} cpiConfig={cpiConfig}/> : null }
        { stepOneSubmitted && ((stepTwoSubmitted && stepThreeSubmitted && stepTwoData.calcCPIValue) || hasFutureRIError) ? <StepFour stepOneData={stepOneData} stepTwoData={stepTwoData} stepThreeData={stepThreeData} resetForm={this.resetForm} generateNotice={this.generateNotice} print={this.print}/> : null }

        {renderSectionOneCompletedButtons()}
      </>
    );
  }

  renderSectionTwo() {
    const {stepOneData, stepTwoData, stepThreeData } = this.state;
    const formData = {...stepOneData, ...stepTwoData, ...stepThreeData }
    return <GeneratedNoticePhase1 formData={formData} editInformation={this.editInformation} />;
  }
}

const mapStateToProps = (state) => {
  return {
    cpiConfig: state.config.cpiConfig,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      navigate: NavigateActions.navigate,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NoticeGenerator);
